import React from 'react'

const Button = (props) => {
  return (
    <div className='auth-button'>
      <button className={props.style}>{props.title}</button>
    </div>
  )
}
export default Button
